import * as tslib_1 from "tslib";
import { lazyAddLandmarkKeyboardNavigation } from 'owa-mail-landmarks';
export default function () {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyAddLandmarkKeyboardNavigation.import()];
                case 1:
                    (_a.sent())();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=initializeLandmarkKeyboardNavigation.js.map